module.exports = __webpack_public_path__ + "media/images/sp/specials/common/benefit/benefit_free-04c3ef5bf2fe5d45c4cc1b1aaa187450.jpg";